import React from 'react';
import clsx from 'clsx';
import { ListItem, type ListItemProps, ListItemText, styled } from '@mui/material';

import { Icon } from 'app/main/components';
import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import withRouter from '@fuse/core/withRouter';
import FuseNavBadge from '../../FuseNavBadge';

interface StyledListItemProps extends ListItemProps {
	activeClassName?: string;
	end?: boolean;
	to?: string;
}

const StyledListItem = styled(ListItem)<StyledListItemProps>(({ theme }) => ({
	color: theme.palette.text.primary,
	textDecoration: 'none!important',
	minHeight: 48,
	'&.active': {
		backgroundColor: `${theme.palette.secondary.main}!important`,
		color: `${theme.palette.secondary.contrastText}!important`,
		pointerEvents: 'none',
		'& .fuse-list-item-text-primary': {
			color: 'inherit'
		},
		'& .fuse-list-item-icon': {
			color: 'inherit'
		}
	},
	'& .fuse-list-item-icon': {},
	'& .fuse-list-item-text': {
		padding: '0 0 0 16px'
	}
}));

function FuseNavHorizontalItem(props) {
	const { item } = props;

	return React.useMemo(
		() => (
			<StyledListItem
				component={NavLinkAdapter}
				to={item.url}
				activeClassName="active"
				className={clsx('fuse-list-item')}
				end={item.end}
				role="button"
			>
				{item.icon && (
					<Icon
						icon={item.icon}
						className={clsx('fuse-list-item-icon shrink-0 text-16', item.iconClass)}
						color="action"
					/>
				)}

				<ListItemText
					className="fuse-list-item-text"
					primary={item.title}
					classes={{ primary: 'text-13 fuse-list-item-text-primary' }}
				/>

				{item.badge && <FuseNavBadge className="ltr:ml-8 rtl:mr-8" badge={item.badge} />}
			</StyledListItem>
		),
		[item.badge, item.end, item.icon, item.iconClass, item.title, item.url]
	);
}

const NavHorizontalItem = withRouter(React.memo(FuseNavHorizontalItem));

export default NavHorizontalItem;
